import { Dispatch, SetStateAction, useEffect } from 'react';
import useClient from './useClient';
import { ClientStatus } from '../../../model/ClientStatus';
import { ClientResponse } from '../../../model/ClientResponse';

interface ReturnType<T> {
  wrapClient(): void;
  data: T;
  setData: Dispatch<SetStateAction<T>>;
  status: ClientStatus;
  refetch(): void;
}

type ClientCall<T> = (...args) => Promise<ClientResponse<T>>;

export default <T> (client: ClientCall<T>, args: unknown[], deps = []): ReturnType<T> => {
  const {
    wrapClient, data, setData, status,
  } = useClient<T>(client);

  useEffect(() => {
    wrapClient(...args)
      .catch(() => { /* noop */ });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  const refetch = (): void => {
    wrapClient(...args)
      .catch(() => { /* noop */ });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  return {
    wrapClient, data, setData, status, refetch,
  };
};
